import React, { HTMLAttributes } from 'react';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';
import { Button, Popup, ToggleGroup } from '../../../components';
import { ImmutableParagraphOnboardingQuestionEntity } from '..';
import useClasses from '../../../hooks/useClasses';

import './style.scss';
import usePopup from '../../../hooks/usePopup';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphOnboardingQuestionEntity;
  setCountQuestions: (number) => void;
  countQuestions: number;
  instanceOfParagraph: number;
  isInvalidSubmitAttempted: boolean;
}

const ParagraphOnboardingQuestion: React.FC<Props> = ({
  entity,
  setCountQuestions,
  countQuestions,
  instanceOfParagraph,
  isInvalidSubmitAttempted,
}) => {
  const { buildClass } = useClasses('ParagraphOnboardingQuestion');
  const { t } = useTranslation();

  const popup = usePopup('onboarding_popup', {
    closeOnOutsideClick: true,
    closeOnEscape: true,
    restoreFocusOnClose: true,
  });

  const [value, setValue] = React.useState<string | null>(null);
  const question = entity.getIn(['field_title', 0, 'value'], '');
  const bodyExplainer = entity.getIn(['field_text', 0, 'value'], '');
  const titleExplainer = entity.getIn(['field_title_explainer', 0, 'value'], '');
  const linkTitle = String(entity.getIn(['field_link', 0, 'title'], ''));
  const linkUri = String(entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'], '')));

  const entityId = String(entity.getIn(['id', 0, 'value']));

  function handleChange(val: string) {
    if (instanceOfParagraph === countQuestions) {
      setCountQuestions(countQuestions + 1);
    }

    if (val === 'yes') {
      popup.open();
    }

    setValue(val);
  }

  const shouldShowError = isInvalidSubmitAttempted && !value;

  return (
    <div className={buildClass()}>
      {popup.isOpen && (
        <Popup
          title={titleExplainer}
          closeButtonText={t('pages.onboarding.question_modal.close')}
          cta={(linkTitle && linkUri) && (
            <Button secondarySmall icon="outbound-link" className={buildClass('button')} href={linkUri} onClick={() => popup.close()}>
              {linkTitle}
            </Button>
          )}
          {...popup.popupProps}
        >
          <WysiwygField
            property="schema:text"
            className={buildClass('body-explainer')}
            html={bodyExplainer}
          />
        </Popup>
      )}
      <ToggleGroup
        id={`onboarding-question-${entityId}`}
        label={question}
        type="binary"
        options={[
          { label: t('pages.onboarding.question.yes'), value: 'yes' },
          { label: t('pages.onboarding.question.no'), value: 'no' },
        ]}
        selectedValue={value ?? undefined}
        onChange={handleChange}
        error={shouldShowError ? t('pages.onboarding.required') : undefined}
      />
    </div>
  );
};

export default ParagraphOnboardingQuestion;
